import React, {Component} from 'react';
import {observer} from 'mobx-react';

import MarkupTemplateThemeSelect from './MarkupTemplateThemeSelect';
import MarkupTemplateSettings from './MarkupTemplateSettings';

@observer export default class MarkupTemplateThemeSettings extends Component {
	render() {
		/** @type {SettingsContext} */
		const context = this.props.context;

		return (
			<div>
				<MarkupTemplateThemeSelect context={context} />
				<MarkupTemplateSettings context={context} />
			</div>
		);
	}
}